import BottomCustomer from 'components/BottomCustomer'
import PointInfo from 'components/PointInfo'
import TopBanner from 'components/TopBanner'
import ModalContext from 'contexts/ModalContext';
import React, { useEffect, useState, useContext } from 'react';
import useProfileStore from 'services/store/ProfileModule'
import moment from 'moment';
import 'moment/locale/th';
import { GetCustomerProfile } from 'services/Api/Module/Customer'
import useTranslations from 'i18n/useTranslations';
import PullToRefresh from 'components/pullToRefresh/PullToRefresh';
import PointInfoTier from 'components/PointInfoTier';

const Profile = () => {
  const [refreshing, setRefreshing] = useState(false)
  const { lang, supportedLangs, setLang } = useTranslations(); // สำหรับเปลี่ยนภาษา
  const { t } = useTranslations();
  const { mAlert } = useContext(ModalContext);
  moment.locale('th');
  const [profile, setProfile] = useState(null);
  const lineProfile = useProfileStore();
  const handleRefresh = () => {
    console.log('handleRefresh!!!')
    setRefreshing(true)
    onLoad();
  }
  const fetchGetProfile = async (payload) => {
    try {
        const response = await GetCustomerProfile({ params: payload });
        const resData = response?.data;
        console.log(response.data)
        setProfile(resData?.resultData);
        setRefreshing(false)
    } catch (err) {
        console.log('err ', err);
        setRefreshing(false)
        mAlert.info({
            title: "แจ้งเตือน",
            subTitle: "มีบางอย่างผิดพลาด",
            content: "",
            onClose: () => { },
        });
    }
};
  const onLoad = () =>  {
    const payload = {
      lineUid: lineProfile?.lineUid
    };
    fetchGetProfile(payload)
    console.log('fetchdi',lineProfile?.lineUid)
  }

  useEffect(() => {
    onLoad()
  }, [lineProfile, lang]);
  const getGender = (gender, lang) => {
    if (lang === 'th') {
      switch (gender) {
        case '0':
          return 'ชาย';
        case '1':
          return 'หญิง';
        case '2':
          return 'ไม่ระบุ';
        default:
          return '';
      }
    } else {
      switch (gender) {
        case '0':
          return 'Male';
        case '1':
          return 'Female';
        case '2':
          return 'unspecified';
        default:
          return '';
      }
    }
  };
  
  const formatDateWithBuddhistYear = (date, lang) => {
    const momentDate = moment(date);
    let formattedDate;
    if (lang === 'th') {
      formattedDate = momentDate.locale('th').format('DD MMMM');
      const buddhistYear = parseInt(momentDate.format('YYYY')) + 543;
      return `${formattedDate} ${buddhistYear}`;
    } else {
      formattedDate = momentDate.locale('en').format('DD MMMM YYYY');
      return formattedDate;
    }
  };
  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `${match[1]}-${match[2]}-${match[3]}`;
    }
    return phoneNumber;
  };

  return (
    <PullToRefresh
      refreshing={refreshing}
      onRefresh={handleRefresh}
    >
      <div id="pageProfile">
        <main id="top">
          <div className="wrapContent">
            <TopBanner />

            <section id="pProfile">
              <div className="bProfile">
                <div className="bDisplay">
                  <div className="bPic">
                    <img src={lineProfile?.profile.pictureUrl? lineProfile.profile.pictureUrl : "assets/img/logo/logo-color.svg"} alt="" />
                  </div>
                  <h1>{lang == 'th'? 'คุณ':''}{profile?.firstName} {profile?.lastName}</h1>
                </div>
                <PointInfoTier
                  point={profile?.pointOnHand} 
                  profile={profile} 
                  expiredDate={profile?.expiredDate} 
                  expiredPoint={profile?.expiredPoint}
                  tierConfig={profile?.tierConfig ?? []}
                />
              </div>
            </section>
            <section id="pProfileinfo">
              <div className="bInfo">
                <h2>{t.profile.personal} <a href="/profile-edit" className="btnEdit">{t.profile.edit}<i></i></a></h2>
                <div className="bGroup">
                  <div className="bRow">
                    <h3>{t.profile.name}</h3>
                    <p>{profile?.firstName} {profile?.lastName}</p>
                  </div>
                  <div className="bRow">
                    <h3>{t.profile.phone}</h3>
                    <p>{profile?.contactNumber? formatPhoneNumber(profile.contactNumber):''}</p>
                  </div>
                  <div className="bRow">
                    <h3>{t.profile.birthday}</h3>
                    <p>{profile?.birthday ? formatDateWithBuddhistYear(profile.birthday,lang) : ''}</p>
                  </div>
                  <div className="bRow">
                    <h3>{t.profile.gender}</h3>
                    <p>{getGender(profile?.gender,lang)}</p>
                  </div>
                  <div className="bRow">
                    <h3>{t.profile.email}</h3>
                    <p>{profile?.email}</p>
                  </div>
                  <div className="bRow">
                    <h3>{t.profile.userId}</h3>
                    <p>{profile?.custCode}</p>
                  </div>
                </div>
                <hr />
                <div className="bGroup">
                  <h2>{t.profile.address}</h2>
                  <p>{profile?.address} {profile?.subDistrict} {profile?.district} {profile?.province} {profile?.postCode}</p>
                </div>
              </div>
            </section>
            <BottomCustomer profile={"active"}/>
          </div>
        </main>
      </div>
      </PullToRefresh>
  );
}

export default Profile;
